import React from "react";
import { ASSIGNED_TASKS, MyTasksListKey, TaskNote, toDate } from "../../../redux/myTasks";
import PersonLink from "./PersonLink";

const formatDate = (mysqlDateTime: string): string =>
  toDate(mysqlDateTime).toLocaleDateString("en-US", { month: "long", day: "numeric" });

export interface TaskSecondaryLineProps {
  tab: MyTasksListKey;
  note: TaskNote;
  complete: boolean;
}

/**
 * The row's byline: who posted it (Your Tasks); or, for Assigned Tasks -
 * where the assigner isn't the one completing it - who it's assigned to and
 * whether they've finished it yet.
 */
const TaskSecondaryLine = ({ tab, note, complete }: TaskSecondaryLineProps) => {
  if (tab !== ASSIGNED_TASKS) {
    return (
      <>
        Posted by <PersonLink userId={note.created_by}>{note.creator_user_full_name}</PersonLink> on{" "}
        {formatDate(note.date_created)}
      </>
    );
  }

  return complete ? (
    <>
      Completed by <PersonLink userId={note.reminder_user}>{note.reminder_user_full_name}</PersonLink> on{" "}
      {formatDate(note.date_complete)}
    </>
  ) : (
    <>
      Assigned to <PersonLink userId={note.reminder_user}>{note.reminder_user_full_name}</PersonLink> on{" "}
      {formatDate(note.date_created)}
    </>
  );
};

export default TaskSecondaryLine;
